import React from 'react'
import {SocialComponent} from '../utils/links'

function Box({title, text, button, tags, contact}) {
    return (
        <div className="box-section">
            <div>
                <h4 className="title box-title" style={{paddingTop:"10px"}}>{title}</h4>
                <p style={{padding:"20px", paddingBottom:"0px"}}>{text}</p>
                <div style={{padding:"20px"}}>
                {
                    tags && tags.map(tag=>{
                        return <span className="tag" key={tag}>{tag}</span>
                    })
                }
                    <div style={{width:"50%", margin:"auto"}}>
                    {
                        contact && <SocialComponent classStyle="social-sidebar"/>
                    }
                    </div>
                </div>
            </div>
            {button}
        </div>
    )
}

export default Box
